<template>
  <TemplateModal
    ref="modal"
    center empty
    width="735"
    :text="{
      title: {
        create: localStorage.translations.pages.statistic_employee.tables.geopozitsiya,
      },
    }"
  >
    <template v-slot:activator>
      <div class="location" @click="$refs.modal.openModal()">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.9028 5.98096C11.3095 5.98096 10.7295 6.1569 10.2361 6.48655C9.74278 6.81619 9.35826 7.28473 9.13119 7.83291C8.90413 8.38109 8.84472 8.98428 8.96048 9.56623C9.07623 10.1482 9.36195 10.6827 9.78151 11.1023C10.2011 11.5218 10.7356 11.8076 11.3176 11.9233C11.8995 12.0391 12.5027 11.9797 13.0509 11.7526C13.5991 11.5255 14.0676 11.141 14.3972 10.6477C14.7269 10.1543 14.9028 9.5743 14.9028 8.98096C14.9019 8.18559 14.5856 7.42305 14.0232 6.86064C13.4607 6.29822 12.6982 5.98186 11.9028 5.98096ZM11.9028 10.481C11.6062 10.481 11.3162 10.393 11.0695 10.2282C10.8228 10.0633 10.6305 9.82907 10.517 9.55498C10.4035 9.28089 10.3738 8.97929 10.4317 8.68832C10.4895 8.39735 10.6324 8.13008 10.8422 7.9203C11.052 7.71052 11.3192 7.56766 11.6102 7.50978C11.9012 7.4519 12.2028 7.48161 12.4769 7.59514C12.7509 7.70867 12.9852 7.90093 13.15 8.1476C13.3149 8.39428 13.4028 8.68428 13.4028 8.98096C13.4024 9.37864 13.2442 9.75991 12.963 10.0411C12.6818 10.3223 12.3005 10.4805 11.9028 10.481Z"
            fill="#F2F2F2"
          />
          <path
            d="M17.6674 3.2117C16.242 1.78672 14.3394 0.940225 12.3266 0.835587C10.3138 0.73095 8.33366 1.37559 6.76824 2.64509C5.20282 3.91459 4.16314 5.71895 3.84985 7.70994C3.53656 9.70092 3.97187 11.7374 5.07178 13.4263L10.7393 22.1269C10.8654 22.3205 11.0379 22.4796 11.241 22.5897C11.4441 22.6998 11.6716 22.7574 11.9026 22.7574C12.1337 22.7574 12.3611 22.6998 12.5642 22.5897C12.7674 22.4796 12.9398 22.3205 13.0659 22.1269L18.7336 13.4263C19.7542 11.8596 20.2052 9.98968 20.0111 8.12999C19.817 6.2703 18.9895 4.53385 17.6674 3.2117ZM17.4768 12.6075L11.9026 21.1645L6.3284 12.6075C4.62215 9.98819 4.98811 6.48287 7.19854 4.27234C7.81629 3.65458 8.54966 3.16454 9.35679 2.83021C10.1639 2.49588 11.029 2.3238 11.9026 2.3238C12.7763 2.3238 13.6414 2.49588 14.4485 2.83021C15.2556 3.16454 15.989 3.65458 16.6067 4.27234C18.8172 6.48287 19.1831 9.98819 17.4768 12.6075Z"
            fill="#F2F2F2"
          />
        </svg>
      </div>
    </template>
    <BaseInput class="mb-4" type="select" v-model="markerSeleted" :items="markersFormat" />
    <Map :markers="markersFormat" height="400" :center="markerCentered" />
    <BaseButton
      text="OK"
      default_icon="button-done"
      @click="$refs.modal.closeModal()"
    />
  </TemplateModal>
</template>

<script>
import Map from 'components/map/Map'

export default {
  name: 'TimeControlShowEmployeeDayLocal',
  props: {
    edit: Boolean,
    locations: Array,
  },
  components: {
    Map,
  },
  data: () => ({
    dialog: false,
    markerSeleted: null,
  }),
  watch: {
    dialogStatus() {
      if (this.dialogStatus && this.markersFormat && this.markersFormat.length) {
        this.markerSeleted = this.markersFormat[this.markersFormat.length - 1].id
      }
    },
  },
  computed: {
    dialogStatus() {
      return this.$refs.modal && this.$refs.modal.dialog
    },
    markersFormat() {
      let result = []
      for (let locationKey in this.locations) {
        let obj = {
          id: Number(locationKey) + 1,
          name: '№ ' + (Number(locationKey) + 1),
          lat: this.locations[locationKey].lat,
          lng: this.locations[locationKey].long,
        }
        result.push(obj)
      }
      return result
    },
    markerCentered() {
      if (this.markerSeleted) {
        const marker = this.markersFormat.find((i) => i.id === this.markerSeleted)
        return [marker.lat, marker.lng]
      }
      return null
    },
  },
}
</script>

<style lang="scss" scoped>
.location {
  background: #277faf;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
  cursor: pointer;
}
.travel-map {
  height: 400px;
  width: 100%;
}
</style>
